import valid from 'card-validator'

export const creditCard = number => {
  return valid.number(number)
}

export const creditCardExpiration = dateExpiration => {
  return valid.expirationDate(dateExpiration)
}
